'use strict';

namespace Core {

    angular.module('core')
        .directive('stickyElement', (): ng.IDirective => {
            return <ng.IDirective>{
                restrict: 'E',
                template:
                '<div class="sticky-wrapper {{wrapperClass}}"' +
                ' data-bottom-limit-id="{{bottomLimitId > 0 ? bottomLimitId : \'0\'}}">' +
                    '<div class="sticky-content"></div>' +
                '</div>',
                transclude: true,
                compile: (el: JQuery, attrs: any, transclude: any) => {
                    return $scope => {
                        let stickyTopOffset = 0;
                        const fixedClass = 'fixed';
                        const absoluteClass = 'absolute';
                        const $stickyWrapper = el.find('.sticky-wrapper');
                        const $stickyContent = el.find('.sticky-content');
                        const bottomLimit = 'true' === attrs.bottomLimit;
                        const bottomSelector =
                            parseInt(attrs.bottomLimitId,10) > 0 ? `[data-id=${attrs.bottomLimitId}]` : '.page-content';


                        const debounceThreshold = 100;
                        const resizeStickyContent = _.debounce(() => {
                            const stickyWrapperWidth = $stickyWrapper.width();
                            const stickyContentWidth = $stickyContent.outerWidth();
                            if (stickyContentWidth !== stickyWrapperWidth) {
                                    $stickyContent.css({width: stickyWrapperWidth + 'px'});
                                    $stickyWrapper.css({height: $stickyContent.outerHeight() + 'px'});
                            }
                        }, debounceThreshold);


                        const checkStickyOffset = () => {
                            const checkOffset = $stickyWrapper.offset().top;
                            if (!stickyTopOffset || (!$stickyWrapper.hasClass(fixedClass) &&
                                stickyTopOffset !== checkOffset)) {
                                stickyTopOffset = checkOffset;
                            }
                        };


                        const handleScroll = () => {
                            checkStickyOffset();
                            const scrollOffset = $(window).scrollTop();
                            let isAtBottomLimit = false;

                            if (bottomLimit) {
                                const $pageContent = $(bottomSelector);
                                if ($pageContent.length && $stickyWrapper.hasClass(fixedClass)) {
                                    const bottomLimit = $pageContent.offset().top  + $pageContent.outerHeight();
                                    const currentBottom = scrollOffset + $stickyContent.outerHeight();

                                    if (bottomLimit <= currentBottom) {
                                        isAtBottomLimit = true;
                                        if (!$stickyWrapper.hasClass(absoluteClass)) {
                                            $stickyWrapper.addClass(absoluteClass);
                                            $stickyContent.css({top:(bottomLimit - $stickyContent.outerHeight())+'px'});
                                        }
                                    } else {
                                        if ($stickyWrapper.hasClass(absoluteClass)) {
                                            $stickyWrapper.removeClass(absoluteClass);
                                            $stickyContent.css({top: 0});
                                        }
                                    }
                                }
                            }

                            if (!isAtBottomLimit) {
                                if (scrollOffset >= stickyTopOffset && !$stickyWrapper.hasClass(fixedClass)) {
                                    const wrapperHeight = $stickyWrapper.outerHeight();
                                    if (wrapperHeight) {
                                        const contentWidth = $stickyContent.outerWidth();
                                        $stickyWrapper.css({height: wrapperHeight + 'px'});
                                        $stickyContent.css({width: contentWidth + 'px'});
                                        $stickyWrapper.addClass(fixedClass);
                                        window.addEventListener('resize', resizeStickyContent, false);
                                    }
                                } else if (scrollOffset < stickyTopOffset && $stickyWrapper.hasClass(fixedClass)) {
                                    $stickyWrapper.removeClass(fixedClass);
                                    $stickyWrapper.removeAttr('style');
                                    $stickyContent.removeAttr('style');
                                    window.removeEventListener('resize', resizeStickyContent, false);
                                }
                            }
                        };


                        transclude($scope, clone => {
                            $stickyContent.append(clone);
                            $scope.wrapperClass = attrs.wrapperClass;
                            $scope.bottomLimitId = attrs.bottomLimitId;

                            /// Watch the height of the content in the sticky wrapper. Height can change as the data is
                            /// being loaded in the sticky element. If the height of the wrapper is zero, it will not
                            /// stick.
                            let initialContentHeight = $stickyContent.outerHeight();
                            $scope.$watch(() => {
                                const contentHeight = $stickyContent.outerHeight();
                                const wrapperHeight = $stickyWrapper.outerHeight();
                                if (0 === initialContentHeight && contentHeight > 0) {
                                    initialContentHeight = -1;
                                    handleScroll();
                                } else if (contentHeight !== wrapperHeight && $stickyWrapper.hasClass(fixedClass)) {
                                    $stickyWrapper.css({height: contentHeight + 'px'});
                                }
                            });

                            window.addEventListener('scroll', handleScroll, false);
                            $scope.$on('$destroy', function () {
                                window.removeEventListener('scroll', handleScroll, false);
                            });
                        });
                    };
                }
            };
        });
}
